import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGitLabSastIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 56,
	height: 56,
	viewBox: "0 0 56 56",
	fill: "none",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M55.0676 22.1632L54.9889 21.9544L47.367 1.30254C47.2119 0.897778 46.9372 0.554414 46.5825 0.321717C46.2278 0.0929752 45.8136 -0.0171949 45.3967 -0.00611682C44.9794 0.00496136 44.5791 0.184967 44.2498 0.451889C43.9244 0.726474 43.6881 1.09855 43.5733 1.51748L38.4269 17.8646H17.5874L12.441 1.51748C12.3294 1.09627 12.0927 0.722329 11.7645 0.448863C11.4352 0.181941 11.035 0.0263335 10.6179 0.00305541C10.2007 -0.0202227 9.78673 0.0899471 9.4318 0.318689C9.07791 0.552386 8.80356 0.89539 8.64746 1.29952L1.01085 21.9423L0.935035 22.1511C-0.162183 25.1275 -0.297618 28.3937 0.549158 31.4569C1.39594 34.5201 3.17901 37.2145 5.62954 39.1339L5.65581 39.1552L5.72578 39.2067L17.3367 48.2339L23.0809 52.7475L26.5799 55.4901C26.9892 55.8127 27.4889 55.9874 28.0028 55.9874C28.5166 55.9874 29.0163 55.8127 29.4257 55.4901L32.9246 52.7475L38.6691 48.2339L50.3499 39.1521L50.379 39.1358C52.824 37.2161 54.6031 34.5164 55.4484 31.4574C56.294 28.3982 56.1604 25.1367 55.0676 22.1632Z",
			fill: "#E24329"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M55.0679 22.1635L54.9889 21.9547C51.275 22.7461 47.7753 24.3793 44.7398 26.7377L28.0078 39.879C33.7005 44.3562 38.6632 48.2462 38.6632 48.2462L50.344 39.1644L50.3734 39.1481C52.8217 37.2207 54.6036 34.5274 55.4501 31.4656C56.2968 28.4038 56.1627 25.1527 55.0679 22.1635Z",
			fill: "#FC6D26"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.3367 48.2465L23.0809 52.7601L26.5799 55.5027C26.9892 55.8253 27.4889 56 28.0028 56C28.5166 56 29.0163 55.8253 29.4257 55.5027L32.9246 52.7601L38.6689 48.2465C38.6689 48.2465 33.7002 44.3445 28.0078 39.8793C22.3154 44.3445 17.3367 48.2465 17.3367 48.2465Z",
			fill: "#FCA326"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.2571 26.7378C8.22397 24.377 4.72506 22.7414 1.01085 21.9467L0.935035 22.1556C-0.162183 25.1319 -0.297618 28.3982 0.549158 31.4609C1.39594 34.5237 3.17901 37.2181 5.62954 39.1375L5.65581 39.1587L5.72578 39.2102L17.3367 48.2374C17.3367 48.2374 22.2962 44.3442 28.0078 39.879C33.7194 44.3442 38.6689 48.2374 38.6689 48.2374L11.2571 26.7378Z",
			fill: "#FC6D26"
		})
	]
});
export default SvgGitLabSastIcon;
